var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2707_487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7212 17.3422L20.1612 18.7522L19.4112 20.0522L16.2212 18.2122V14.5222H17.7212V17.3422ZM24.2212 17.5222C24.2212 21.3922 21.0912 24.5222 17.2212 24.5222C13.3512 24.5222 10.2212 21.3922 10.2212 17.5222C10.2212 17.1822 10.2512 16.8522 10.3012 16.5222H2.22119V4.52222H20.2212V11.2022C22.5812 12.3322 24.2212 14.7322 24.2212 17.5222ZM10.9012 14.5222C11.0812 14.1622 11.2712 13.8222 11.5012 13.4922C11.4112 13.5222 11.3212 13.5222 11.2212 13.5222C9.56119 13.5222 8.22119 12.1822 8.22119 10.5222C8.22119 8.86222 9.56119 7.52222 11.2212 7.52222C12.8812 7.52222 14.2212 8.86222 14.2212 10.5222C14.2212 10.7722 14.1812 11.0222 14.1212 11.2522C15.0612 10.7922 16.1112 10.5222 17.2212 10.5222C17.5612 10.5222 17.8912 10.5522 18.2212 10.6022V8.52222C17.1212 8.52222 16.2212 7.63222 16.2212 6.52222H6.22119C6.22119 7.63222 5.33119 8.52222 4.22119 8.52222V12.5222C5.33119 12.5222 6.22119 13.4222 6.22119 14.5222H10.9012ZM22.2212 17.5222C22.2212 14.7622 19.9812 12.5222 17.2212 12.5222C14.4612 12.5222 12.2212 14.7622 12.2212 17.5222C12.2212 20.2822 14.4612 22.5222 17.2212 22.5222C19.9812 22.5222 22.2212 20.2822 22.2212 17.5222Z",
    fill: "#E0565F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2707_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.221191 0.522217)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIcon3);
export default __webpack_public_path__ + "static/media/welcome-icon-3.e53775a9.svg";
export { ForwardRef as ReactComponent };